import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=60f0ada4&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=60f0ada4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0ada4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f0ada4')) {
      api.createRecord('60f0ada4', component.options)
    } else {
      api.reload('60f0ada4', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=60f0ada4&scoped=true", function () {
      api.rerender('60f0ada4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fileCenter/preview.vue"
export default component.exports